import DPServices from "@dp/services";
export var CACHE_TYPE;

(function (CACHE_TYPE) {
  CACHE_TYPE[CACHE_TYPE["LOCAL"] = 0] = "LOCAL";
  CACHE_TYPE[CACHE_TYPE["SESSION"] = 1] = "SESSION";
})(CACHE_TYPE || (CACHE_TYPE = {}));

var POLICIES = {};
POLICIES[DPServices.Core.hashCode(DPServices.Config.postfix.RESOURCE_BUNDLE)] = {
  ttl: 10000000,
  methods: ["get"],
  cacheType: CACHE_TYPE.LOCAL //

};
POLICIES[DPServices.Core.hashCode(DPServices.Config.postfix.RESTAURANT_DETAILS)] = {
  ttl: 30000,
  methods: ["get"],
  cacheType: CACHE_TYPE.LOCAL //

};
POLICIES[DPServices.Core.hashCode(DPServices.Config.postfix.CATEGORY_MENU_ITEMS)] = {
  ttl: 600000,
  methods: ["get"],
  cacheType: CACHE_TYPE.LOCAL //

};
POLICIES[DPServices.Core.hashCode(DPServices.Config.postfix.APP_INIT)] = {
  ttl: 100000,
  methods: ["get"],
  cacheType: CACHE_TYPE.LOCAL //

};
POLICIES[DPServices.Core.hashCode(DPServices.Config.postfix.MENU_ITEM_DETAILS)] = {
  ttl: 600000,
  methods: ["get"],
  cacheType: CACHE_TYPE.LOCAL //

};
POLICIES[DPServices.Core.hashCode(DPServices.Config.postfix.SEARCH_RESTAURANT)] = {
  ttl: 100000,
  methods: ["get"],
  cacheType: CACHE_TYPE.LOCAL //

};
POLICIES[DPServices.Core.hashCode(DPServices.Config.postfix.MENU_DAY_PART_API)] = {
  ttl: 1000000,
  methods: ["get"],
  cacheType: CACHE_TYPE.SESSION
};
POLICIES[DPServices.Core.hashCode(DPServices.Config.postfix.MENU_ITEMS_86ED)] = {
  ttl: 100000,
  methods: ["get"],
  cacheType: CACHE_TYPE.SESSION
};
POLICIES[DPServices.Core.hashCode(DPServices.Config.postfix.GET_WINE_LIST)] = {
  ttl: 86400000,
  methods: ["get"],
  cacheType: CACHE_TYPE.LOCAL
};
export default {
  POLICIES: POLICIES
};